import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import BettingCenterView from './view/index.jsx';
import { isEmpty } from 'mojito/utils';
import { connect } from 'react-redux';
import { selectActiveTab } from './store/selectors';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const {
    utils: BetslipUtils,
    selectors: { selectReceipt, selectBetslip, selectOverask, selectBetslipStatus },
} = MojitoServices.Betslip;
const { selectBetCount } = MojitoServices.Bets.openBetsSelectors;
const isShallowEqual = MojitoCore.Base.objUtils.isShallowEqual;

class BettingCenterController extends UIViewImplementation {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return !isShallowEqual(this.props, nextProps);
    }

    render() {
        const { selectedTab, betslipItemsCount, openBetCount } = this.props;

        return (
            <BettingCenterView
                config={this.config.view}
                selectedTab={selectedTab}
                betslipItemsCount={betslipItemsCount}
                openBetsCount={openBetCount}
            />
        );
    }
}

const getBetslipItemsCount = state => {
    const betslip = selectBetslip(state);
    const isOverask =
        BetslipUtils.isOverask(selectBetslipStatus(state)) || !isEmpty(selectOverask(state));
    const isReceipt = !!selectReceipt(state);
    return isOverask || isReceipt ? NaN : BetslipUtils.getSingleBetsCount(betslip);
};

const mapStateToProps = state => ({
    betslipItemsCount: getBetslipItemsCount(state),
    openBetCount: selectBetCount(state),
    selectedTab: selectActiveTab(state),
});

export default connect(mapStateToProps)(BettingCenterController);
